import { Space } from '../../../../components/core-v2'
import Icon from '../../../../components/core-v2/atoms/Icon'
import IconButton from '../../../../components/core-v2/molecules/iconButton'
import LinkIcon from '../../../../components/core-v2/molecules/linkIcon'

type WizardButtonProps = {
  canMoveBack: boolean
  canMoveNext: boolean
  onMoveBack?: () => void
  onMoveNext: () => void
}

export const WizardButtons = ({
  canMoveBack,
  canMoveNext,
  onMoveBack,
  onMoveNext
}: WizardButtonProps) => {
  if (canMoveBack) {
    return (
      <Space isflex justifyContent="space-between" my={6}>
        <LinkIcon
          data-testid="previous"
          disabled={false}
          icon={<Icon name="chevronLeft" size="small" />}
          iconPosition="left"
          text="Previous"
          onClick={() => onMoveBack()}
        />
        <IconButton
          data-testid="continue"
          disabled={!canMoveNext}
          icon={<Icon name="chevronRight" size="small" />}
          iconPosition="right"
          operationType="progress"
          text="Save and continue"
          onClick={() => onMoveNext()}
        />
      </Space>
    )
  }

  return (
    <Space isflex justifyContent="flex-end" my={6}>
      <IconButton
        data-testid="continue"
        disabled={!canMoveNext}
        icon={<Icon name="chevronRight" size="small" />}
        iconPosition="right"
        operationType="progress"
        text="Save and continue"
        onClick={() => onMoveNext()}
      />
    </Space>
  )
}
